import posthog from 'posthog-js'
import type { DashboardUser } from '@/auth/context'

// The dashboard and the project portal report to one PostHog project, separate from the
// store's (USA-379). The project key is public: it can only send events.
const POSTHOG_KEY = 'phc_sQShd33i73y8sWyAzfgzLYsN6ahzsDiTa8hAREz2aD57'
const POSTHOG_HOST = 'https://us.i.posthog.com'

// Production promotes the bundle staging already served, so only the hostname tells them apart.
export const PRODUCTION_HOSTNAMES = ['dashboard.shopusars.com']

// Local testing opts in with VITE_POSTHOG_LOCAL=1 on the dev server; builds never honor it.
const localOptIn = import.meta.env.DEV && import.meta.env.VITE_POSTHOG_LOCAL === '1'

let started = false

export function initAnalytics(hostname = window.location.hostname, optIn = localOptIn): boolean {
  const production = PRODUCTION_HOSTNAMES.includes(hostname)
  if (started || !(production || optIn)) return started
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: 'history_change',
    autocapture: true,
    // Dashboard pages show customer data: replays keep layout and clicks, never text or inputs.
    session_recording: { maskAllInputs: true, maskTextSelector: '*' },
  })
  posthog.register({ app: 'dashboard', environment: production ? 'production' : 'local' })
  started = true
  return started
}

export function identifyStaff(user: DashboardUser): void {
  if (!started) return
  posthog.identify(user.email, { email: user.email, name: user.name })
}
